import * as React from 'react';
import { getNativeVersion } from '@shopee-user/food-driver-customization-logic';
import styles from './style.scss';

export default function VersionNumber({ className }: { className?: string }) {
  const nativeVersion = getNativeVersion();
  const version = nativeVersion ? `v.${nativeVersion}` : '';

  return (
    <div className={className}>
      <div className={styles.versionNumber}>{version}</div>
    </div>
  );
}
